import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../theme/palette";
import Divider from "@mui/material/Divider";
import classNames from "classnames";
export function GrDivider(props) {
    const { orientation = "horizontal", variant = "fullWidth", spacing = 2, children, className, style } = props;
    const marginY = orientation === "horizontal" ? spacing : 0;
    const marginX = orientation === "vertical" ? spacing : 0;
    return (_jsx(Divider, { className: classNames("GrDivider", className), orientation: orientation, variant: variant, style: {
            margin: `${marginY}px ${marginX}px`,
            borderColor: palette.grey025,
            ...style,
        }, children: children }));
}
//# sourceMappingURL=GrDivider.js.map